export enum LockStage {
  APPLY,
  DEPOSIT,
  UPDATE,
  UPDATE_STAKE,
  UPDATE_STAKE2,
  UPDATE_OWNER,
  UPDATE_TAX_CONTRACT,
  UPDATE_BEFORE_LITIGATIONS,
  WITHDRAW,
  SWITCH_STAKE,
  CANCEL_STAKE,
  CANCEL_APPLICATION,
  MINT_NOTE,
  MINT_IOU,
  CLAIM_NOTE,
  ACCEPT,
  CONFIRM_ACCEPT,
  START_WAITING_PERIOD,
  UPDATE_LOCATION,
  CONFIRM_UPDATE_LOCATION,
  CONFIRM_APPLY,
  CONFIRM_DEPOSIT,
  CONFIRM_UPDATE,
  CONFIRM_UPDATE_STAKE,
  CONFIRM_UPDATE_STAKE2,
  CONFIRM_UPDATE_OWNER,
  CONFIRM_UPDATE_TAX_CONTRACT,
  CONFIRM_UPDATE_BEFORE_LITIGATIONS,
  CONFIRM_WITHDRAW,
  CONFIRM_SWITCH_STAKE,
  CONFIRM_CANCEL_STAKE,
  CONFIRM_CANCEL_APPLICATION,
  CONFIRM_MINT_NOTE,
  CONFIRM_MINT_IOU,
  CONFIRM_CLAIM_NOTE,
  CONFIRM_START_WAITING_PERIOD,
  SETTINGS,
  ADMIN_SETTINGS,
  TX_CONFIRMED,
}
